module.exports = __webpack_public_path__ + "img/PS1.a128063d.png";